import { toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-901f8bb4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"red","cursor":"pointer","font-size":"18px","font-weight":"bolder","margin-right":"2px"} }, "!", -1))
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { key: 3 }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { key: 5 }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"margin":"0px 0px 20px 20px"} }, "请选择您要执行的动作", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_miezz_select = _resolveComponent("miezz-select")!
  const _component_miezz_button = _resolveComponent("miezz-button")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_lock = _resolveComponent("lock")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_miezz_text_ellipsis = _resolveComponent("miezz-text-ellipsis")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_miezz_page_list = _resolveComponent("miezz-page-list")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_miezz_modal = _resolveComponent("miezz-modal")!
  const _component_order_pool_choose_service = _resolveComponent("order-pool-choose-service")!
  const _component_miezz_input = _resolveComponent("miezz-input")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_order_process = _resolveComponent("order-process")!
  const _component_order_task = _resolveComponent("order-task")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_miezz_page_list, {
      ref: "ref-miezz-page-list",
      modelValue: _ctx.list,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.list) = $event)),
      onHandleGet: _ctx.handleGet,
      onHandleTopButtonClick: _ctx.handleTopButtonClick,
      onHandleRowButtonClick: _ctx.handleRowButtonClick,
      onHandleBottomButtonClick: _ctx.handleBottomButtonClick,
      onHandleRadioSearch: _ctx.handleRadioSearch,
      onHandleRowDbClick: _ctx.handleRowDbClick,
      onHandleRowClick: _ctx.handleRowClick
    }, {
      "dynamic-search-customize": _withCtx(({ model }) => [
        (model.Where.Prop == 'DynamicSearch_Color')
          ? (_openBlock(), _createBlock(_component_miezz_select, {
              key: 0,
              modelValue: model.Where.Value,
              "onUpdate:modelValue": ($event: any) => ((model.Where.Value) = $event),
              options: _ctx.colors,
              clearable: "",
              style: _normalizeStyle(`background-color: ${model.Where.Value}`),
              class: "select-color"
            }, {
              default: _withCtx(({ model }) => [
                _createElementVNode("div", {
                  style: _normalizeStyle(`background-color: ${model.value}; margin: 0px -27px 0px -15px; color: #FFF`)
                }, _toDisplayString(model.value), 5)
              ]),
              _: 2
            }, 1032, ["modelValue", "onUpdate:modelValue", "options", "style"]))
          : (model.Where.Prop == 'DynamicSearch_Lock')
            ? (_openBlock(), _createBlock(_component_miezz_select, {
                key: 1,
                modelValue: model.Where.Value,
                "onUpdate:modelValue": ($event: any) => ((model.Where.Value) = $event),
                options: _ctx.lockOptions,
                clearable: ""
              }, null, 8, ["modelValue", "onUpdate:modelValue", "options"]))
            : _createCommentVNode("", true),
        (model.Where.Prop == 'DynamicSearch_Client')
          ? (_openBlock(), _createBlock(_component_miezz_select, {
              key: 2,
              modelValue: model.Where.Value,
              "onUpdate:modelValue": ($event: any) => ((model.Where.Value) = $event),
              options: _ctx.clients,
              clearable: ""
            }, null, 8, ["modelValue", "onUpdate:modelValue", "options"]))
          : (model.Where.Prop == 'DynamicSearch_CompanySource')
            ? (_openBlock(), _createBlock(_component_miezz_select, {
                key: 3,
                modelValue: model.Where.Value,
                "onUpdate:modelValue": ($event: any) => ((model.Where.Value) = $event),
                options: _ctx.companySources,
                clearable: ""
              }, null, 8, ["modelValue", "onUpdate:modelValue", "options"]))
            : (model.Where.Prop == 'DynamicSearch_SupplierCompanyLabel')
              ? (_openBlock(), _createBlock(_component_miezz_select, {
                  key: 4,
                  modelValue: model.Where.Value,
                  "onUpdate:modelValue": ($event: any) => ((model.Where.Value) = $event),
                  label: model.Where.Label,
                  "onUpdate:label": ($event: any) => ((model.Where.Label) = $event),
                  options: _ctx._supplierCompanies,
                  "filter-Method": (q) => _ctx.filterSupplierCompanies(q, model.Where.Value),
                  onHandleFocus: ($event: any) => (
          _ctx.filterSupplierCompanies(model.Where.Label, model.Where.Value)
        ),
                  labelKey: "NameZh/NameEn",
                  valueKey: "Id",
                  clearable: ""
                }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "onUpdate:label", "options", "filter-Method", "onHandleFocus"]))
              : (model.Where.Prop == 'DynamicSearch_LoadingPortId')
                ? (_openBlock(), _createBlock(_component_miezz_select, {
                    key: 5,
                    modelValue: model.Where.Value,
                    "onUpdate:modelValue": ($event: any) => ((model.Where.Value) = $event),
                    options: _ctx.loadingPorts,
                    clearable: ""
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "options"]))
                : (model.Where.Prop == 'DynamicSearch_DeliveryPortId')
                  ? (_openBlock(), _createBlock(_component_miezz_select, {
                      key: 6,
                      modelValue: model.Where.Value,
                      "onUpdate:modelValue": ($event: any) => ((model.Where.Value) = $event),
                      options: _ctx.deliveryPorts,
                      clearable: ""
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "options"]))
                  : (model.Where.Prop == 'DynamicSearch_DeliveryPlaceLabel')
                    ? (_openBlock(), _createBlock(_component_miezz_select, {
                        key: 7,
                        modelValue: model.Where.Value,
                        "onUpdate:modelValue": ($event: any) => ((model.Where.Value) = $event),
                        options: _ctx.deliveryPlaces,
                        clearable: ""
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "options"]))
                    : (model.Where.Prop == 'DynamicSearch_ShipName')
                      ? (_openBlock(), _createBlock(_component_miezz_select, {
                          key: 8,
                          modelValue: model.Where.Value,
                          "onUpdate:modelValue": ($event: any) => ((model.Where.Value) = $event),
                          options: _ctx.shipNames,
                          clearable: ""
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "options"]))
                      : (model.Where.Prop == 'DynamicSearch_VoyageNumber')
                        ? (_openBlock(), _createBlock(_component_miezz_select, {
                            key: 9,
                            modelValue: model.Where.Value,
                            "onUpdate:modelValue": ($event: any) => ((model.Where.Value) = $event),
                            options: _ctx.voyageNumbers,
                            clearable: ""
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "options"]))
                        : (model.Where.Prop == 'DynamicSearch_Flight')
                          ? (_openBlock(), _createBlock(_component_miezz_select, {
                              key: 10,
                              modelValue: model.Where.Value,
                              "onUpdate:modelValue": ($event: any) => ((model.Where.Value) = $event),
                              options: _ctx.flights,
                              clearable: ""
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "options"]))
                          : (model.Where.Prop == 'DynamicSearch_RailwayNumber')
                            ? (_openBlock(), _createBlock(_component_miezz_select, {
                                key: 11,
                                modelValue: model.Where.Value,
                                "onUpdate:modelValue": ($event: any) => ((model.Where.Value) = $event),
                                options: _ctx.railwayNumbers,
                                clearable: ""
                              }, null, 8, ["modelValue", "onUpdate:modelValue", "options"]))
                            : (model.Where.Prop == 'DynamicSearch_CarrierId')
                              ? (_openBlock(), _createBlock(_component_miezz_select, {
                                  key: 12,
                                  modelValue: model.Where.Value,
                                  "onUpdate:modelValue": ($event: any) => ((model.Where.Value) = $event),
                                  options: _ctx.carriers,
                                  clearable: ""
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "options"]))
                              : (model.Where.Prop == 'DynamicSearch_ContainerType')
                                ? (_openBlock(), _createBlock(_component_miezz_select, {
                                    key: 13,
                                    modelValue: model.Where.Value,
                                    "onUpdate:modelValue": ($event: any) => ((model.Where.Value) = $event),
                                    options: _ctx.containerTypes,
                                    clearable: ""
                                  }, null, 8, ["modelValue", "onUpdate:modelValue", "options"]))
                                : (model.Where.Prop == 'DynamicSearch_ContainerNo')
                                  ? (_openBlock(), _createBlock(_component_miezz_select, {
                                      key: 14,
                                      modelValue: model.Where.Value,
                                      "onUpdate:modelValue": ($event: any) => ((model.Where.Value) = $event),
                                      options: _ctx.containerNos,
                                      clearable: ""
                                    }, null, 8, ["modelValue", "onUpdate:modelValue", "options"]))
                                  : (model.Where.Prop == 'DynamicSearch_CustomerServiceId')
                                    ? (_openBlock(), _createBlock(_component_miezz_select, {
                                        key: 15,
                                        modelValue: model.Where.Value,
                                        "onUpdate:modelValue": ($event: any) => ((model.Where.Value) = $event),
                                        options: _ctx.customerServices,
                                        clearable: ""
                                      }, null, 8, ["modelValue", "onUpdate:modelValue", "options"]))
                                    : (model.Where.Prop == 'DynamicSearch_TaskUserId')
                                      ? (_openBlock(), _createBlock(_component_miezz_select, {
                                          key: 16,
                                          modelValue: model.Where.Value,
                                          "onUpdate:modelValue": ($event: any) => ((model.Where.Value) = $event),
                                          options: _ctx.taskUsers,
                                          clearable: ""
                                        }, null, 8, ["modelValue", "onUpdate:modelValue", "options"]))
                                      : (model.Where.Prop == 'DynamicSearch_SalesmanId')
                                        ? (_openBlock(), _createBlock(_component_miezz_select, {
                                            key: 17,
                                            modelValue: model.Where.Value,
                                            "onUpdate:modelValue": ($event: any) => ((model.Where.Value) = $event),
                                            options: _ctx.searchSalesmans,
                                            clearable: ""
                                          }, null, 8, ["modelValue", "onUpdate:modelValue", "options"]))
                                        : (model.Where.Prop == 'DynamicSearch_Type')
                                          ? (_openBlock(), _createBlock(_component_miezz_select, {
                                              key: 18,
                                              modelValue: model.Where.Value,
                                              "onUpdate:modelValue": ($event: any) => ((model.Where.Value) = $event),
                                              options: _ctx.types,
                                              clearable: ""
                                            }, null, 8, ["modelValue", "onUpdate:modelValue", "options"]))
                                          : (model.Where.Prop == 'DynamicSearch_TransportDirection')
                                            ? (_openBlock(), _createBlock(_component_miezz_select, {
                                                key: 19,
                                                modelValue: model.Where.Value,
                                                "onUpdate:modelValue": ($event: any) => ((model.Where.Value) = $event),
                                                options: _ctx.EnumTransportDirectionOption,
                                                number: true,
                                                clearable: ""
                                              }, null, 8, ["modelValue", "onUpdate:modelValue", "options"]))
                                            : (model.Where.Prop == 'DynamicSearch_TransportType')
                                              ? (_openBlock(), _createBlock(_component_miezz_select, {
                                                  key: 20,
                                                  modelValue: model.Where.Value,
                                                  "onUpdate:modelValue": ($event: any) => ((model.Where.Value) = $event),
                                                  options: _ctx.EnumTransportTypeOption,
                                                  number: true,
                                                  clearable: ""
                                                }, null, 8, ["modelValue", "onUpdate:modelValue", "options"]))
                                              : (model.Where.Prop == 'DynamicSearch_TransportContainerLoad')
                                                ? (_openBlock(), _createBlock(_component_miezz_select, {
                                                    key: 21,
                                                    modelValue: model.Where.Value,
                                                    "onUpdate:modelValue": ($event: any) => ((model.Where.Value) = $event),
                                                    options: _ctx.EnumTransportContainerLoadOption,
                                                    number: true,
                                                    clearable: ""
                                                  }, null, 8, ["modelValue", "onUpdate:modelValue", "options"]))
                                                : (model.Where.Prop == 'DynamicSearch_ServiceRemark')
                                                  ? (_openBlock(), _createBlock(_component_miezz_select, {
                                                      key: 22,
                                                      modelValue: model.Where.Value,
                                                      "onUpdate:modelValue": ($event: any) => ((model.Where.Value) = $event),
                                                      options: _ctx.serviceRemarks,
                                                      clearable: ""
                                                    }, null, 8, ["modelValue", "onUpdate:modelValue", "options"]))
                                                  : (model.Where.Prop == 'DynamicSearch_Status')
                                                    ? (_openBlock(), _createBlock(_component_miezz_select, {
                                                        key: 23,
                                                        modelValue: model.Where.Value,
                                                        "onUpdate:modelValue": ($event: any) => ((model.Where.Value) = $event),
                                                        options: _ctx.EnumOrderStatusOption,
                                                        number: true,
                                                        clearable: ""
                                                      }, null, 8, ["modelValue", "onUpdate:modelValue", "options"]))
                                                    : (model.Where.Prop == 'DynamicSearch_BookingStatus')
                                                      ? (_openBlock(), _createBlock(_component_miezz_select, {
                                                          key: 24,
                                                          modelValue: model.Where.Value,
                                                          "onUpdate:modelValue": ($event: any) => ((model.Where.Value) = $event),
                                                          options: _ctx.EnumBookingStatusOption,
                                                          number: true,
                                                          clearable: ""
                                                        }, null, 8, ["modelValue", "onUpdate:modelValue", "options"]))
                                                      : (
          model.Where.Prop == 'DynamicSearch_DeparturePortCustomsStatus'
        )
                                                        ? (_openBlock(), _createBlock(_component_miezz_select, {
                                                            key: 25,
                                                            modelValue: model.Where.Value,
                                                            "onUpdate:modelValue": ($event: any) => ((model.Where.Value) = $event),
                                                            options: _ctx.EnumCustomsStatusOption,
                                                            number: true,
                                                            clearable: ""
                                                          }, null, 8, ["modelValue", "onUpdate:modelValue", "options"]))
                                                        : (
          model.Where.Prop == 'DynamicSearch_DestinationPortCustomsStatus'
        )
                                                          ? (_openBlock(), _createBlock(_component_miezz_select, {
                                                              key: 26,
                                                              modelValue: model.Where.Value,
                                                              "onUpdate:modelValue": ($event: any) => ((model.Where.Value) = $event),
                                                              options: _ctx.EnumCustomsStatusOption,
                                                              number: true,
                                                              clearable: ""
                                                            }, null, 8, ["modelValue", "onUpdate:modelValue", "options"]))
                                                          : (model.Where.Prop == 'DynamicSearch_DeparturePortTrunkStatus')
                                                            ? (_openBlock(), _createBlock(_component_miezz_select, {
                                                                key: 27,
                                                                modelValue: model.Where.Value,
                                                                "onUpdate:modelValue": ($event: any) => ((model.Where.Value) = $event),
                                                                options: _ctx.EnumTrunkStatusOption,
                                                                number: true,
                                                                clearable: ""
                                                              }, null, 8, ["modelValue", "onUpdate:modelValue", "options"]))
                                                            : (
          model.Where.Prop == 'DynamicSearch_DestinationPortTrunkStatus'
        )
                                                              ? (_openBlock(), _createBlock(_component_miezz_select, {
                                                                  key: 28,
                                                                  modelValue: model.Where.Value,
                                                                  "onUpdate:modelValue": ($event: any) => ((model.Where.Value) = $event),
                                                                  options: _ctx.EnumTrunkStatusOption,
                                                                  number: true,
                                                                  clearable: ""
                                                                }, null, 8, ["modelValue", "onUpdate:modelValue", "options"]))
                                                              : (
          model.Where.Prop == 'DynamicSearch_DeparturePortExpressStatus'
        )
                                                                ? (_openBlock(), _createBlock(_component_miezz_select, {
                                                                    key: 29,
                                                                    modelValue: model.Where.Value,
                                                                    "onUpdate:modelValue": ($event: any) => ((model.Where.Value) = $event),
                                                                    options: _ctx.EnumExpressStatusOption,
                                                                    number: true,
                                                                    clearable: ""
                                                                  }, null, 8, ["modelValue", "onUpdate:modelValue", "options"]))
                                                                : (
          model.Where.Prop == 'DynamicSearch_DestinationPortExpressStatus'
        )
                                                                  ? (_openBlock(), _createBlock(_component_miezz_select, {
                                                                      key: 30,
                                                                      modelValue: model.Where.Value,
                                                                      "onUpdate:modelValue": ($event: any) => ((model.Where.Value) = $event),
                                                                      options: _ctx.EnumExpressStatusOption,
                                                                      number: true,
                                                                      clearable: ""
                                                                    }, null, 8, ["modelValue", "onUpdate:modelValue", "options"]))
                                                                  : (
          model.Where.Prop ==
          'DynamicSearch_DeparturePortContainerTrailerStatus'
        )
                                                                    ? (_openBlock(), _createBlock(_component_miezz_select, {
                                                                        key: 31,
                                                                        modelValue: model.Where.Value,
                                                                        "onUpdate:modelValue": ($event: any) => ((model.Where.Value) = $event),
                                                                        options: _ctx.EnumDeparturePortContainerTrailerStatusOption,
                                                                        number: true,
                                                                        clearable: ""
                                                                      }, null, 8, ["modelValue", "onUpdate:modelValue", "options"]))
                                                                    : (
          model.Where.Prop ==
          'DynamicSearch_DestinationPortContainerTrailerStatus'
        )
                                                                      ? (_openBlock(), _createBlock(_component_miezz_select, {
                                                                          key: 32,
                                                                          modelValue: model.Where.Value,
                                                                          "onUpdate:modelValue": ($event: any) => ((model.Where.Value) = $event),
                                                                          options: _ctx.EnumDestinationPortContainerTrailerStatusOption,
                                                                          number: true,
                                                                          clearable: ""
                                                                        }, null, 8, ["modelValue", "onUpdate:modelValue", "options"]))
                                                                      : (
          model.Where.Prop == 'DynamicSearch_DeparturePortIncomingGoodsStatus'
        )
                                                                        ? (_openBlock(), _createBlock(_component_miezz_select, {
                                                                            key: 33,
                                                                            modelValue: model.Where.Value,
                                                                            "onUpdate:modelValue": ($event: any) => ((model.Where.Value) = $event),
                                                                            options: _ctx.EnumIncomingGoodsStatusOption,
                                                                            number: true,
                                                                            clearable: ""
                                                                          }, null, 8, ["modelValue", "onUpdate:modelValue", "options"]))
                                                                        : (
          model.Where.Prop == 'DynamicSearch_DestinationPortIncomingGoodsStatus'
        )
                                                                          ? (_openBlock(), _createBlock(_component_miezz_select, {
                                                                              key: 34,
                                                                              modelValue: model.Where.Value,
                                                                              "onUpdate:modelValue": ($event: any) => ((model.Where.Value) = $event),
                                                                              options: _ctx.EnumIncomingGoodsStatusOption,
                                                                              number: true,
                                                                              clearable: ""
                                                                            }, null, 8, ["modelValue", "onUpdate:modelValue", "options"]))
                                                                          : (model.Where.Prop == 'DynamicSearch_CollectionSubmitStatus')
                                                                            ? (_openBlock(), _createBlock(_component_miezz_select, {
                                                                                key: 35,
                                                                                modelValue: model.Where.Value,
                                                                                "onUpdate:modelValue": ($event: any) => ((model.Where.Value) = $event),
                                                                                options: _ctx.EnumSubmitStatusOption,
                                                                                clearable: ""
                                                                              }, null, 8, ["modelValue", "onUpdate:modelValue", "options"]))
                                                                            : (model.Where.Prop == 'DynamicSearch_PaymentSubmitStatus')
                                                                              ? (_openBlock(), _createBlock(_component_miezz_select, {
                                                                                  key: 36,
                                                                                  modelValue: model.Where.Value,
                                                                                  "onUpdate:modelValue": ($event: any) => ((model.Where.Value) = $event),
                                                                                  options: _ctx.EnumSubmitStatusOption,
                                                                                  clearable: ""
                                                                                }, null, 8, ["modelValue", "onUpdate:modelValue", "options"]))
                                                                              : (model.Where.Prop == 'DynamicSearch_SalerSubmitStatus')
                                                                                ? (_openBlock(), _createBlock(_component_miezz_select, {
                                                                                    key: 37,
                                                                                    modelValue: model.Where.Value,
                                                                                    "onUpdate:modelValue": ($event: any) => ((model.Where.Value) = $event),
                                                                                    options: _ctx.EnumSubmitStatusOptionSaler,
                                                                                    clearable: ""
                                                                                  }, null, 8, ["modelValue", "onUpdate:modelValue", "options"]))
                                                                                : (
          model.Where.Prop == 'DynamicSearch_CollectionSettlementStatus'
        )
                                                                                  ? (_openBlock(), _createBlock(_component_miezz_select, {
                                                                                      key: 38,
                                                                                      modelValue: model.Where.Value,
                                                                                      "onUpdate:modelValue": ($event: any) => ((model.Where.Value) = $event),
                                                                                      options: _ctx.EnumSettlementStatusOption,
                                                                                      clearable: ""
                                                                                    }, null, 8, ["modelValue", "onUpdate:modelValue", "options"]))
                                                                                  : (model.Where.Prop == 'DynamicSearch_PaymentSettlementStatus')
                                                                                    ? (_openBlock(), _createBlock(_component_miezz_select, {
                                                                                        key: 39,
                                                                                        modelValue: model.Where.Value,
                                                                                        "onUpdate:modelValue": ($event: any) => ((model.Where.Value) = $event),
                                                                                        options: _ctx.EnumSettlementStatusOption,
                                                                                        clearable: ""
                                                                                      }, null, 8, ["modelValue", "onUpdate:modelValue", "options"]))
                                                                                    : _createCommentVNode("", true)
      ]),
      column: _withCtx(({ model, row }) => [
        (model.Prop == 'Color')
          ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
              _createVNode(_component_miezz_button, {
                model: {
            Code: 'mark',
            Type: 'color',
          },
                color: row.Color,
                onHandleClick: (arg1, arg2) => _ctx.handleRowButtonClick(arg1, row, arg2)
              }, null, 8, ["color", "onHandleClick"])
            ]))
          : _createCommentVNode("", true),
        (model.Prop == 'Code')
          ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
              (row.StowageOrder && row.Status != _ctx.EnumOrderStatus.Canceled)
                ? (_openBlock(), _createBlock(_component_el_tooltip, {
                    key: 0,
                    content: "可拼入",
                    placement: "top",
                    effect: "dark"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_3
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (row.Lock)
                ? (_openBlock(), _createBlock(_component_el_icon, {
                    key: 1,
                    class: "lock"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_lock)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createElementVNode("span", null, _toDisplayString(row.Code), 1)
            ]))
          : (model.Prop == 'ClientInfo' && row.Clients.length > 0)
            ? (_openBlock(), _createBlock(_component_el_popover, {
                key: 2,
                placement: "top-start",
                trigger: "hover",
                disabled: row.Clients.length == 1,
                "popper-class": "popover-tooltip",
                effect: "dark"
              }, {
                reference: _withCtx(() => [
                  (_ctx.powers.contains('OrderManagement_Pool'))
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        onClick: ($event: any) => (_ctx.handleRowCommand(model.Prop, row)),
                        style: {"width":"100%","display":"inline-block"}
                      }, [
                        _createVNode(_component_miezz_text_ellipsis, {
                          text: row.ClientInfo
                        }, null, 8, ["text"])
                      ], 8, _hoisted_4))
                    : (_openBlock(), _createBlock(_component_miezz_text_ellipsis, {
                        key: 1,
                        text: row.ClientInfo
                      }, null, 8, ["text"]))
                ]),
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.Clients, (item, i) => {
                    return (_openBlock(), _createElementBlock("div", { key: i }, _toDisplayString(item), 1))
                  }), 128))
                ]),
                _: 2
              }, 1032, ["disabled"]))
            : (model.Prop == 'ClientInfo')
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, "暂无数据"))
              : _createCommentVNode("", true),
        (
          _ctx.powers.contains('OrderManagement_Order_CustomerService') &&
          model.Prop == 'CustomerServiceId'
        )
          ? (_openBlock(), _createElementBlock("a", {
              key: 4,
              onClick: ($event: any) => (_ctx.handleRowCommand(model.Prop, row))
            }, [
              _createVNode(_component_miezz_text_ellipsis, {
                text: row.CustomerServiceLabel ?? '暂无数据',
                miezzIcon: "assign"
              }, null, 8, ["text"])
            ], 8, _hoisted_6))
          : (model.Prop == 'CustomerServiceId')
            ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(row.CustomerServiceLabel ?? "暂无数据"), 1))
            : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue", "onHandleGet", "onHandleTopButtonClick", "onHandleRowButtonClick", "onHandleBottomButtonClick", "onHandleRadioSearch", "onHandleRowDbClick", "onHandleRowClick"]),
    _createVNode(_component_miezz_modal, {
      modelValue: _ctx.modalBeforeAdd,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.modalBeforeAdd) = $event))
    }, {
      default: _withCtx(() => [
        _hoisted_8,
        _createVNode(_component_el_form, {
          ref: "ref-form-before-add",
          model: _ctx.modalBeforeAddData,
          rules: _ctx.modalBeforeAddRules,
          "label-width": "50px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { prop: "Type" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_radio_group, {
                  modelValue: _ctx.modalBeforeAddData.Type,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.modalBeforeAddData.Type) = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_radio, { label: "add" }, {
                      default: _withCtx(() => [
                        _createTextVNode("订单包含一个委托书（先添加委托书并由委托书直接生成订单）")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_radio, { label: "add-pre" }, {
                      default: _withCtx(() => [
                        _createTextVNode("订单包含多个委托书（先不添加委托书，后续通过配载栈关联订单）")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_miezz_modal, {
      modelValue: _ctx.modalChooseService,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.modalChooseService) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_order_pool_choose_service, {
          modelValue: _ctx.modalChooseService,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.modalChooseService) = $event)),
          onHandleSubmit: _ctx.handleChooseServiceSubmit
        }, null, 8, ["modelValue", "onHandleSubmit"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_miezz_modal, {
      modelValue: _ctx.modalAdd,
      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.modalAdd) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          ref: "ruleForm",
          model: _ctx.form.Data,
          rules: _ctx.form.Rules,
          "label-width": "200px",
          inline: false
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "订单编号",
              prop: "Code"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_miezz_input, {
                  modelValue: _ctx.form.Data.Code,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.Data.Code) = $event)),
                  pattern: "[0-9a-zA-Z]",
                  upperCase: true,
                  trimAll: true,
                  placeholder: "选填，未填写时系统会自动生成订单编号"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "业务类型",
              required: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, {
                  prop: "TransportDirection",
                  class: "direction"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_miezz_select, {
                      modelValue: _ctx.form.Data.TransportDirection,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.Data.TransportDirection) = $event)),
                      options: _ctx.EnumTransportDirectionOption
                    }, null, 8, ["modelValue", "options"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  prop: "TransportType",
                  class: "type"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_miezz_select, {
                      modelValue: _ctx.form.Data.TransportType,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.Data.TransportType) = $event)),
                      options: _ctx.EnumTransportTypeOption
                    }, null, 8, ["modelValue", "options"])
                  ]),
                  _: 1
                }),
                (
            _ctx.form.Data.TransportType == _ctx.EnumTransportType.Sea ||
            _ctx.form.Data.TransportType == _ctx.EnumTransportType.Railway
          )
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 0,
                      prop: "TransportContainerLoad",
                      class: "containerLoad"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_miezz_select, {
                          modelValue: _ctx.form.Data.TransportContainerLoad,
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.Data.TransportContainerLoad) = $event)),
                          options: 
              _ctx.EnumTransportContainerLoadOption.filter((it) => it.Value != 3)
            
                        }, null, 8, ["modelValue", "options"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "Port of  Loading/装货港",
              prop: "LoadingPortId"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_miezz_select, {
                  modelValue: _ctx.form.Data.LoadingPortId,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.form.Data.LoadingPortId) = $event)),
                  label: _ctx.form.Data.LoadingPortLabel,
                  "onUpdate:label": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.form.Data.LoadingPortLabel) = $event)),
                  options: _ctx.formLoadingPorts,
                  remote: true,
                  remoteMethod: _ctx.getLoadingPorts
                }, null, 8, ["modelValue", "label", "options", "remoteMethod"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "Port of Delivery/目的港",
              prop: "DeliveryPortId"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_miezz_select, {
                  modelValue: _ctx.form.Data.DeliveryPortId,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.form.Data.DeliveryPortId) = $event)),
                  label: _ctx.form.Data.DeliveryPortLabel,
                  "onUpdate:label": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.form.Data.DeliveryPortLabel) = $event)),
                  options: _ctx.formDeliveryPorts,
                  remote: true,
                  remoteMethod: _ctx.getDeliveryPorts
                }, null, 8, ["modelValue", "label", "options", "remoteMethod"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              prop: "CustomerServiceId",
              label: "客服"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_miezz_select, {
                  modelValue: _ctx.form.Data.CustomerServiceId,
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.form.Data.CustomerServiceId) = $event)),
                  label: _ctx.form.Data.CustomerServiceLabel,
                  "onUpdate:label": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.form.Data.CustomerServiceLabel) = $event)),
                  options: _ctx.putCustomerServices,
                  clearable: false
                }, null, 8, ["modelValue", "label", "options"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_miezz_modal, {
      modelValue: _ctx.modalAssignCustomerService,
      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.modalAssignCustomerService) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          ref: "ref-form-assign-customer-service",
          model: _ctx.modalAssignCustomerServiceData,
          rules: _ctx.modalAssignCustomerServiceRules,
          "label-width": "150px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              prop: "CustomerServiceId",
              label: "客服"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_miezz_select, {
                  modelValue: _ctx.modalAssignCustomerServiceData.CustomerServiceId,
                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.modalAssignCustomerServiceData.CustomerServiceId) = $event)),
                  label: _ctx.modalAssignCustomerServiceData.CustomerServiceLabel,
                  "onUpdate:label": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.modalAssignCustomerServiceData.CustomerServiceLabel) = $event)),
                  options: _ctx.putCustomerServices,
                  clearable: false
                }, null, 8, ["modelValue", "label", "options"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_miezz_modal, {
      modelValue: _ctx.modalPutBusinessCycle,
      "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.modalPutBusinessCycle) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          ref: "ref-form-put-business-cycle",
          model: _ctx.modalPutBusinessCycleData,
          rules: _ctx.modalPutBusinessCycleRules,
          "label-width": "150px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              prop: "BusinessCycle",
              label: "业务所属周期"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_date_picker, {
                  modelValue: _ctx.modalPutBusinessCycleData.BusinessCycle,
                  "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.modalPutBusinessCycleData.BusinessCycle) = $event)),
                  type: "month",
                  class: "form-item-date"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_miezz_modal, {
      modelValue: _ctx.modalProcess,
      "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.modalProcess) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_order_process, {
          modelValue: _ctx.modalProcess,
          "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.modalProcess) = $event)),
          id: _ctx.id
        }, null, 8, ["modelValue", "id"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_order_task, {
      modelValue: _ctx.modalTask,
      "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.modalTask) = $event)),
      url: "/order",
      listPower: "OrderManagement_Order_Task",
      userPower: "OrderManagement_Order",
      id: _ctx.id,
      cancel: _ctx.cancel
    }, null, 8, ["modelValue", "id", "cancel"])
  ], 64))
}